import { render } from "./SettingsMessage.vue?vue&type=template&id=1e0f90e0"
import script from "./SettingsMessage.vue?vue&type=script&lang=js"
export * from "./SettingsMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__